// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__yFF5R","text_danger":"TablaProducto_text_danger__pZKV5","text_success":"TablaProducto_text_success__A0CyR"};